<template>
	<div>
		<!-- <form id="commerce_form" ref="PWRequestForm" method="POST" action="https://pagosweb.com.uy/v3.4/requestprocessor.aspx" enctype="multipart/form-data"></form> -->

		<!-- <form ref="PWRequestForm" method="POST" action="https://pagosweb.com.uy/v3.4/requestprocessor.aspx" enctype="multipart/form-data"></form> -->

		<form id="commerce_form">
			<input type="hidden" class="form-control" name="PWToken" id="PWToken" />
			<!-- <input type="text" class="form-control" name="PWLastFour" id="PWLastFour" />
			<input type="text" class="form-control" name="PWBin" id="PWBin" /> -->
		</form>
	</div>
</template>

<script>
import gql from "graphql-tag"
import axios from "axios"
// import qs from 'querystring'

export default {
	name: "Payment",
	props: ["amount", "paymentMethod", "client", "installments"],
	data() {
		return {
			PAGOS_WEB_PUBLIC_KEY: process.env.VUE_APP_PW_PUBLIC_KEY,

			payment: {
				name: "carlitur",
				email: this.client.email || "",
				image: "https://www.carlitur.uy/logo-dark.png",
				button_label: "Pagar #monto#",
				description: "Checkout",
				currency: "USD",
				amount: 0,
				lang: "ESP",
				form_id: "commerce_form",
				checkout_card: null,
				autoSubmit: "false",
				email_edit: false,
				close_onclick: "false"
			},
			paying: false,
			orderId: null,
			paymentId: null
		}
	},
	mounted() {
		this.payment.amount = this.amount.toString()
		window.PWCheckout.Bind("tokenCreated", this.tokenCreated)
		window.PWCheckout.Bind("closed", this.closedCheckout)
	},
	methods: {
		validate() {
			let validate = {}
			validate.valid = true
			validate.err = ""

			if (!this.paymentMethod) return { valid: false, err: "Cannot validate payment method" }

			if (
				this.paymentMethod.code == "OCA" ||
				this.paymentMethod.code == "VISA" ||
				this.paymentMethod.code == "MASTER"
			) {
				// valido data para tarjetas
			}

			if (this.paymentMethod.code == "ABITAB" || this.paymentMethod.code == "REDPAGOS") {
				// valido data para pagos offline
				// debo tener la cedula del cliente.
				if (!this.client || !this.client.email) return { valid: false, err: "Cannot find client email" }
				if (!this.client || !this.client.document) return { valid: false, err: "Cannot find client document" }
			}

			return validate
		},

		// Ventana PWCheckout cerrada
		closedCheckout(data) {
			//verifico si el proceso sigue o se cancelo.
			// console.log('payment closedCheckout', data)
			if (data.Reason == "CLOSE_BUTTON") {
				this.paying = false
			}
			if (data.Reason == "TOKEN_RECEIVED") {
				this.paying = true
			}
			this.$emit("paymentClosed", this.paying)
		},

		proccessPayment(orderId) {
			console.log("proccessPayment ", orderId)
			this.orderId = orderId
			this.generateTokenAndProccess()
		},

		async generateTokenAndProccess() {
			console.log("generateTokenAndProccess", this.payment)

			if (this.paymentMethod.type == "CARD") {
				window.PWCheckout.SetProperties(this.payment)
				window.PWCheckout.OpenIframeNormal(null, null)
			}

			if (this.paymentMethod.type == "OFFLINE") {
				const paymentMediaId = this.paymentMethod.code
				if (!paymentMediaId) return null

				window.PWCheckout.GetCustomToken(paymentMediaId, this.client.email, this.client.document.number, 2)
			}
			if (this.paymentMethod.type == "BANK") {
				this.processBankPayment(this.paymentMethod)
			}
		},

		tokenCreated() {
			const token = document.querySelector("input[id=PWToken]").value
			console.log("tokenCreated", token)
			this.paymentCreate(token)
		},

		async paymentCreate(token = null) {
			console.log("paymentCreate", this.paymentMethod)

			if (this.paymentMethod) {
				let dataInput = {
					token,
					paymentType: this.paymentMethod.type,
					paymentMethod: this.paymentMethod.code.toString(),
					paymentMethodName: this.paymentMethod.name,
					order: this.orderId,
					installments: parseInt(this.installments)
				}
				console.log(dataInput)

				return this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: OrderPaymentInput!) {
								orderPaymentCreate(data: $data) {
									id
								}
							}
						`,
						variables: {
							data: dataInput
						}
					})
					.then(({ data }) => {
						this.$emit("paymentDone", data.orderPaymentCreate)
						return data.orderPaymentCreate
					})
					.catch((error) => {
						console.log("ERROR", error)
						// this.$emit('paymentDone', error)
					})
			}
		},

		async processBankPayment(paymentMethod) {
			console.log("processBankPayment", paymentMethod)

			// tengo que tokenizar los datos de la compra para obtener el form de redireccion de pagosweb

			let formData = {
				paymentMethod: paymentMethod.code,
				orderId: this.orderId
			}
			const result = await axios.post(`${process.env.VUE_APP_API_URL}/bamboo-pagosweb-gateway`, formData)

			if (result && result.status == 200) {
				console.log("result from bank payment", result.data.data)

				const inputs = result.data.data
				await this.paymentCreate(inputs.transactionSecurityToken)

				const form = document.createElement("form")
				form.setAttribute("method", "POST")
				form.setAttribute("enctype", "multipart/form-data")
				form.setAttribute("action", process.env.VUE_APP_PAGOSWEB)

				for (var index in inputs) {
					let i = document.createElement("input")
					i.type = "hidden"
					i.name = index
					i.value = inputs[index]
					form.appendChild(i)
				}
				document.body.appendChild(form)
				this.$nextTick(() => {
					form.submit()
				})
			}
		}
	}
}
</script>

<style scoped>
.payment-methods {
	margin: 12px 0px;
	display: flex;
	gap: 4px;
	cursor: pointer;
	flex-wrap: wrap;
}

.payment-methods .payment-method {
	border: solid 1px #cecece;
	width: 116px;
	height: 64px;
	flex-grow: 0;
	flex-shrink: 0;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
}
.payment-methods .payment-method:hover {
	background-color: #f3f3f3;
}

.payment-methods .payment-method .selected {
	width: 14px;
	height: 14px;
	background-color: #157eea;
	position: absolute;
	border-radius: 8px;
	top: 6px;
	right: 6px;
	display: none;
}
.payment-methods .payment-method .selected .icon {
	width: 14px;
	height: 14px;
}
.payment-methods .payment-method.selected {
	border-color: #157eea;
}
.payment-methods .payment-method.selected .selected {
	display: block;
}
</style>
